const $ = require('cash-dom');
const Page = require('./page');

var Validator = {
    validate: function($form, errors, scrollToError) {
        this.removeErrors($form);

        for (var e in errors) {
            var $el = $form.find('[data-field="' + errors[e]['field'] + '"]');

            if ($el.length > 0) {
                var $errEl = '<div class="error-msg">' + errors[e]['error_str'] + '</div>';
                $el.addClass('error validation-error');

                if ($el.attr('type') == 'checkbox' && $el.parent('label').length) {
                    $el.parent('label').after($errEl);
                } else {
                    $el.after($errEl);
                }
            }
        }

        if (typeof scrollToError === 'undefined' || scrollToError === true) {
            Page.scrollTo($('.error').first(), 300, -100);
        }
    },
    validateModel: function($form, errors, scrollToError) {
        this.removeErrors($form);

        for (var e in errors) {
            var $el = $('[data-field="' + e + '"]');
            if (!$el.length) {
                $el = $('[name="' + e + '"]');
            }

            if ($el.length > 0) {
                var $errEl = '<div class="error-msg">' + errors[e] + '</div>';
                $el.addClass('error validation-error');

                if ($el.attr('type') == 'checkbox' && $el.parent('label').length) {
                    $el.parent('label').after($errEl);
                } else {
                    $el.after($errEl);
                }
            }
        }

        if (typeof scrollToError === 'undefined' || scrollToError === true) {
            Page.scrollTo($form.find('.error').first(), 300, -100);
        }
    },
    removeErrors: function ($form) {
        $form.find('.validation-error.error').removeClass('error validation-error');
        $form.find('.error-msg').remove();
        $('.error-msg').remove();
    }
}

module.exports = Validator;
